module.exports = __webpack_public_path__ + "img/add_img_af.ff4d8dbe.svg";